@if (showMenu) {
	<div id="VideoSettingsMenu" [ngClass]="menuItemStyles.menu" dropdown vbDropdown #dropdown="bs-dropdown" (mouseenter)="!isMobile && dropdown.show()" (mouseleave)="dropdown.hide()">

		<button type="button" class="flex-center-align gap-1" dropdownToggle vbBtnPrimary>
			<span class="vb-icon vb-icon-center vb-icon-settings"></span>
			<span class="xs-hide"> {{ 'Video_Settings_Title' | translate }} </span>
		</button>

		<ul role="menu" class="dropdown-menu dropdown-menu-right" [ngClass]="[menuItemStyles.menuOrderedList, menuItemStyles.menuDark]" *dropdownMenu>
			@if (showSettings) {
				<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
					<a class="dropdown-item themed-menu-item" [uiSref]="PORTAL_VIDEO_SETTINGS_STATE" [uiParams]="{videoId: video.id, config: { disableFileDownloads: playbackConfig?.disableFileDownloads }}">
						<span class="vb-icon vb-icon-center vb-icon-settings"></span>
						{{ 'VideoDetails' | translate }}
					</a>
				</li>
			}
			@if (showPreposition) {
				<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
					<button type="button" class="dropdown-item themed-menu-item" (click)="VideoPlaybackComponent.isPrepositionOpen = true">
						<span class="glyphicons history"></span>
						{{ 'Media_Videos_Preposition_TabTitle' | translate }}
					</button>
				</li>
			}
			@if (showEditVideo()) {
				<li [ngClass]="menuItemStyles.menuListItem" class="d-none d-lg-block" role="menuitem">
					<a class="dropdown-item themed-menu-item" [uiSref]="PORTAL_VIDEO_EDIT_STATE" [uiParams]="{videoId: video.id}">
						<span class="vb-icon vb-icon-center vb-icon-pencil"></span>
						{{ 'Video_Settings_Edit' | translate }}
					</a>
				</li>
			}
			@if (showReplaceVideo) {
				<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
					<button type="button" class="dropdown-item themed-menu-item" (click)="VideoPlaybackComponent.isReplaceVideoOpen = true">
						<span class="vb-icon vb-icon-center vb-icon-sync"></span>
						{{ 'Media_Videos_ReplaceVideo' | translate }}
					</button>
				</li>
			}
			@if (showApplyLegalHold) {
				<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
					<button type="button" class="dropdown-item themed-menu-item" (click)="applyLegalHold()">
						<span class="vb-icon vb-icon-center vb-icon-lock"></span>
						{{ 'Video_LegalHold_Apply' | translate }}
					</button>
				</li>
			}
			@if (showRemoveLegalHold) {
				<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
					<button type="button" class="dropdown-item themed-menu-item" (click)="removeLegalHold()">
						<span class="glyphicons unlock"></span>
						{{ 'Video_LegalHold_Remove' | translate }}
					</button>
				</li>
			}
			@if (showDeleteVideo) {
				<li [ngClass]="menuItemStyles.menuListItem" role="menuitem">
					<button type="button" class="dropdown-item themed-menu-item" (click)="deleteVideo()">
						<span class="vb-icon vb-icon-center vb-icon-trash"></span>
						{{ 'Media_Videos_Playback_Delete' | translate }}
					</button>
				</li>
			}
		</ul>
	</div>
}
